import { FC, useRef } from 'react'
import Nav from 'react-bootstrap/Nav'
import Tab from 'react-bootstrap/Tab'
import { useIntl } from 'react-intl'

import { MenuDropdown } from '@components/MenuDropdown'

import { useBoolState } from '@/hooks'

const NotificationTopbar: FC = () => {
  const intl = useIntl()
  const ref = useRef<HTMLButtonElement>(null)
  const [isShowDropdown, toggleDropdown, , hideDropdown] = useBoolState()

  return (
    <>
      <button
        ref={ref}
        type="button"
        className="btn btn-icon bg-body btn-color-gray-600 btn-active-color-primary h-40px"
        onClick={toggleDropdown}
      >
        <i className="fa-solid fa-bell fs-4" />
      </button>

      <MenuDropdown
        targetRef={ref}
        isShow={isShowDropdown}
        placement="bottom-end"
        onOuterClick={hideDropdown}
        width={350}
      >
        <Tab.Container defaultActiveKey="new">
          <div className="d-flex justify-content-between align-items-center px-7 pt-3 border-bottom">
            <h5 className="mb-1">{intl.formatMessage({ id: 'topbar_notification.title' })}</h5>

            <Nav className="nav-line-tabs nav-stretch nav-line-tabs-2x fw-medium border-0">
              <Nav.Item>
                <Nav.Link eventKey="new">{intl.formatMessage({ id: 'new' })}</Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link eventKey="seen">{intl.formatMessage({ id: 'seen' })}</Nav.Link>
              </Nav.Item>
            </Nav>
          </div>

          <Tab.Content>
            <Tab.Pane eventKey="new">
              <div className="py-10">
                <div className="text-center text-muted pt-1">
                  {intl.formatMessage({ id: 'topbar_notification.no_result' })}
                </div>
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="seen">
              <div className="py-10">
                <div className="text-center text-muted pt-1">
                  {intl.formatMessage({ id: 'topbar_notification.no_result' })}
                </div>
              </div>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </MenuDropdown>
    </>
  )
}

export { NotificationTopbar }
